module.exports = __webpack_public_path__ + "static/rcw_logo.416b9555.svg";


//////////////////
// WEBPACK FOOTER
// ./~/buoy-config/dist/images/rcw_logo.svg
// module id = 878
// module chunks = 168707334958949